import { CompanyDetailPage } from '@/pages/crm/companies/CompanyDetailPage';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_app/crm/companies/$id')({
	beforeLoad: ({ context }) => requireAnyPermission({ context, anyOf: ['clients.read'], redirectTo: '/dashboard' }),
	component: CompanyDetailRoute,
});

function CompanyDetailRoute() {
	const { id } = Route.useParams();
	return <CompanyDetailPage id={id} />;
}
